import { FormTitle } from '@/components/form-elements/components';
import Switch from '@/components/UI/Switch';
import useAppDispatch from '@/hooks/useAppDispatch';
import useAppSelector from '@/hooks/useAppSelector';
import useNotifications from '@/hooks/useNotification';
import { updateNotification } from '@/redux/actions/user';
import { getUserSelector } from '@/redux/selectors/userSelectors';
import { IUser, IWithUser } from '@/types/models';
import { Box, FormControl } from '@mui/material';
import React, { useCallback, useState } from 'react';
import {
  NotificationContainer,
  NotificationRow,
  SwitchLabel,
} from './components';

interface INotificationSettingsProps extends IWithUser {
  onlyNewMessages?: boolean;
}

const NotificationSettings: React.FC<INotificationSettingsProps> = ({
  user,
  onlyNewMessages = false,
}) => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(getUserSelector) as IUser;
  const { askNotificationPermission } = useNotifications();
  const { id, newMessagesSounds, breakTimesSounds, progressMetersSounds } =
    user || currentUser;
  const [values, setValues] = useState({
    newMessagesSounds,
    breakTimesSounds,
    progressMetersSounds,
  });

  const handleChange = useCallback(
    ({ target: { name, checked } }: React.ChangeEvent<HTMLInputElement>) => {
      if (checked) {
        askNotificationPermission();
      }
      setValues((prev) => ({ ...prev, [name]: checked }));
      dispatch(updateNotification({ id, [name]: checked }));
    },
    [dispatch, id]
  );

  return (
    <Box marginBottom="20px">
      <FormTitle>Notification Sounds</FormTitle>
      <NotificationContainer display="flex" flexDirection="column">
        <FormControl>
          <NotificationRow display="flex" alignItems="center">
            <SwitchLabel>New Messages</SwitchLabel>
            <Switch
              name="newMessagesSounds"
              checked={values.newMessagesSounds}
              onChange={handleChange}
            />
          </NotificationRow>
        </FormControl>
        {!onlyNewMessages && (
          <>
            <FormControl>
              <NotificationRow display="flex" alignItems="center">
                <SwitchLabel>Break Timers</SwitchLabel>
                <Switch
                  name="breakTimesSounds"
                  checked={values.breakTimesSounds}
                  onChange={handleChange}
                />
              </NotificationRow>
            </FormControl>
            <FormControl>
              <NotificationRow display="flex" alignItems="center">
                <SwitchLabel>Progress Meters</SwitchLabel>
                <Switch
                  name="progressMetersSounds"
                  checked={values.progressMetersSounds}
                  onChange={handleChange}
                />
              </NotificationRow>
            </FormControl>
          </>
        )}
      </NotificationContainer>
    </Box>
  );
};

export default NotificationSettings;
